export const isMessageRemoved = (messageId, arr) => {
  for (let i = 0; i < arr.length; i++) {
    const element = arr[i];
    if (element?.message_id === messageId) {
      return element?.status === "success";
    }
  }
};

export const isRemoved = element => {
  return element?.status === "success";
};
